import React, { useState } from 'react'

export default function Ajuda() {
  const [categoriaAtiva, setCategoriaAtiva] = useState('geral')
  const [termoPesquisa, setTermoPesquisa] = useState('')

  const faqs = {
    geral: [
      { pergunta: 'O que é a SIDES Mercado?', resposta: 'A SIDES Mercado é uma plataforma digital 100% moçambicana que conecta agricultores locais diretamente com consumidores, eliminando intermediários e garantindo preços justos para ambos os lados.' },
      { pergunta: 'Como posso criar uma conta?', resposta: "Clique em 'Criar Conta' no canto superior direito, preencha seus dados pessoais e confirme seu email. O processo é gratuito e leva menos de 2 minutos." },
      { pergunta: 'A plataforma é segura?', resposta: 'Sim! Utilizamos criptografia SSL, seguimos as melhores práticas de segurança e estamos em conformidade com a Lei de Proteção de Dados Pessoais de Moçambique.' }
    ],
    compras: [
      { pergunta: 'Quais métodos de pagamento aceitam?', resposta: 'Aceitamos M-Pesa, e-Mola, transferências bancárias, cartões de crédito/débito e pagamento na entrega (apenas para Maputo e Matola).' },
      { pergunta: 'Como funciona a entrega?', resposta: 'Entregamos em Maputo e Matola em 24-48h. Fora destas áreas, trabalhamos com pontos de recolha parceiros. O custo de entrega varia consoante a localização.' },
      { pergunta: 'Posso devolver um produto?', resposta: 'Sim, aceitamos devoluções em 7 dias para produtos não perecíveis. Para produtos frescos, a qualidade é verificada no momento da entrega.' },
      { pergunta: 'Os preços incluem IVA?', resposta: 'Sim, todos os preços na plataforma incluem IVA conforme a legislação moçambicana. O valor total é sempre mostrado antes da confirmação do pedido.' }
    ],
    vendedores: [
      { pergunta: 'Como me torno um agricultor parceiro?', resposta: 'Registe-se como produtor, complete o perfil com documentos válidos e submeta seus produtos. Nossa equipa fará a verificação em até 48h.' },
      { pergunta: 'Quais as comissões da plataforma?', resposta: 'Cobramos uma comissão de 15% sobre as vendas, que inclui processamento de pagamento, suporte ao cliente e manutenção da plataforma.' },
      { pergunta: 'Como recebo os pagamentos?', resposta: 'Os pagamentos são processados semanalmente através de transferência bancária, M-Pesa ou e-Mola, conforme sua preferência.' },
      { pergunta: 'Preciso de fatura?', resposta: 'Sim, emitimos fatura electrónica para todas as transações, em conformidade com a Autoridade Tributária de Moçambique.' }
    ],
    tecnico: [
      { pergunta: 'A plataforma funciona em telemóveis antigos?', resposta: 'Sim, otimizamos a plataforma para funcionar mesmo em dispositivos com poucos recursos e conexões de internet limitadas.' },
      { pergunta: 'Como altero minha palavra-passe?', resposta: 'Aceda ao seu perfil > Configurações de Segurança > Alterar Palavra-passe. Enviaremos um email de confirmação.' },
      { pergunta: 'Não consigo aceder à minha conta', resposta: "Use a opção 'Recuperar Palavra-passe' na página de login ou contacte nosso suporte através do email suporte@sides.co.mz" }
    ]
  }

  const categorias = [
    { id: 'geral', nome: '📋 Geral', icon: '📋' },
    { id: 'compras', nome: '🛒 Compras', icon: '🛒' },
    { id: 'vendedores', nome: '👨‍🌾 Vendedores', icon: '👨‍🌾' },
    { id: 'tecnico', nome: '📱 Técnico', icon: '📱' }
  ]

  const faqsFiltradas = faqs[categoriaAtiva].filter(faq =>
    faq.pergunta.toLowerCase().includes(termoPesquisa.toLowerCase()) ||
    faq.resposta.toLowerCase().includes(termoPesquisa.toLowerCase())
  )

  return (
    <div className="ajuda-container">
      <section className="ajuda-hero">
        <div className="container">
          <div className="hero-content">
            <h1>Centro de Ajuda SIDES</h1>
            <p>Encontre respostas rápidas para suas dúvidas ou entre em contacto com nossa equipa</p>

            <div className="search-bar">
              <input
                type="text"
                placeholder="Pesquisar por palavra-chave (ex: pagamento, entrega, conta...)"
                value={termoPesquisa}
                onChange={(e) => setTermoPesquisa(e.target.value)}
                className="search-input"
              />
              <button className="search-button">🔍 Pesquisar</button>
            </div>
          </div>
        </div>
      </section>

      <div className="ajuda-content">
        <div className="container">
          <div className="ajuda-layout">
            <aside className="categorias-sidebar">
              <h3>Categorias de Ajuda</h3>
              <nav className="categorias-nav">
                {categorias.map(categoria => (
                  <button
                    key={categoria.id}
                    className={`categoria-btn ${categoriaAtiva === categoria.id ? 'active' : ''}`}
                    onClick={() => { setCategoriaAtiva(categoria.id); setTermoPesquisa('') }}
                  >
                    <span className="categoria-icon">{categoria.icon}</span>
                    <span className="categoria-nome">{categoria.nome}</span>
                  </button>
                ))}
              </nav>

              <div className="contacto-rapido">
                <h4>📞 Contacto Rápido</h4>
                <div className="contacto-info">
                  <div className="contacto-item"><strong>Email:</strong> <a href="mailto:suporte@sides.co.mz">suporte@sides.co.mz</a></div>
                  <div className="contacto-item"><strong>Telefone:</strong> <a href="tel:+258852620360">+258 85 262 0360</a></div>
                  <div className="contacto-item"><strong>Horário:</strong> <span>Seg-Sex: 8h-18h</span></div>
                </div>
              </div>
            </aside>

            <main className="faqs-content">
              <div className="faqs-header">
                <h2>{categorias.find(c => c.id === categoriaAtiva)?.nome}</h2>
                <p>Encontre respostas para as dúvidas mais frequentes</p>
              </div>

              {termoPesquisa && (
                <div className="resultados-pesquisa">
                  <p>{faqsFiltradas.length} resultado(s) encontrado(s) para "{termoPesquisa}"</p>
                </div>
              )}

              <div className="faqs-list">
                {faqsFiltradas.length > 0 ? (
                  faqsFiltradas.map((faq, index) => (
                    <FAQItem key={index} pergunta={faq.pergunta} resposta={faq.resposta} />
                  ))
                ) : (
                  <div className="sem-resultados">
                    <h3>😕 Nenhum resultado encontrado</h3>
                    <p>Tente pesquisar com outras palavras-chave ou entre em contacto com nosso suporte.</p>
                  </div>
                )}
              </div>

              <div className="ajuda-extra">
                <div className="ajuda-card">
                  <div className="ajuda-icon">💬</div>
                  <div className="ajuda-content">
                    <h3>Ainda precisa de ajuda?</h3>
                    <p>Nossa equipa de suporte está pronta para ajudá-lo com qualquer dúvida ou problema.</p>
                    <div className="ajuda-actions">
                      <a href="mailto:suporte@sides.co.mz" className="cta-button primary">📧 Enviar Email</a>
                      <a href="tel:+258852620360" className="cta-button secondary">📞 Ligar Agora</a>
                    </div>
                  </div>
                </div>
              </div>
            </main>
          </div>
        </div>
      </div>
    </div>
  )
}

function FAQItem({ pergunta, resposta }) {
  const [aberto, setAberto] = useState(false)

  return (
    <div className={`faq-item ${aberto ? 'aberto' : ''}`}>
      <button className="faq-pergunta" onClick={() => setAberto(!aberto)}>
        <span className="faq-texto">{pergunta}</span>
        <span className="faq-icone">{aberto ? '➖' : '➕'}</span>
      </button>
      {aberto && (
        <div className="faq-resposta">
          <p>{resposta}</p>
        </div>
      )}
    </div>
  )
}


